import { InjectionToken } from '@angular/core';

import { FirebaseOptions } from 'firebase/app';

/**
 * Injection token for providing Firebase configuration options specific to analytics.
 * This token can be used to inject the Firebase configuration required for setting up or
 * initializing Firebase analytics features in an Angular application.
 * Use this token to supply platform-specific configuration details when working in
 * a dependency injection (DI) environment.
 */
export const FIREBASE_CONFIG_IT = new InjectionToken<FirebaseOptions>('analyticsConfigInjectionToken');
